import React from "react";
import { useLang } from "../contexts/LanguageContext";

// Final curated set — 6 real guest experiences for MVP launch
const PHOTOS = [
  {
    src: "https://customer-assets.emergentagent.com/wingman/4d88747a-9285-4415-a858-393ef890ce1a/attachments/0a89fb7712914dd4a3b35073092e2258_image.bin",
    captionAr: "تجربة غداء في منطقة البلد في جدة",
    captionEn: "Lunch Experience in Al-Balad, Jeddah",
    tagAr: "تجربة طعام",
    tagEn: "Dining experience",
  },
  {
    src: "https://customer-assets.emergentagent.com/wingman/4d88747a-9285-4415-a858-393ef890ce1a/attachments/bf44d7dccd324b79a2914a473a0be382_image.bin",
    captionAr: "جولة في منطقة البلد في جدة",
    captionEn: "Tour in Al-Balad, Jeddah",
    tagAr: "جولة ثقافية",
    tagEn: "Cultural tour",
  },
  {
    src: "https://customer-assets.emergentagent.com/wingman/4d88747a-9285-4415-a858-393ef890ce1a/attachments/9b01d96085ff44f5938ccf1ca6fcb639_image.bin",
    captionAr: "رحلة برية في منطقة هدى الشام في جدة",
    captionEn: "Hiking in Huda Al-Sham, Jeddah",
    tagAr: "رحلة برية",
    tagEn: "Land trip",
  },
  {
    src: "https://customer-assets.emergentagent.com/wingman/4d88747a-9285-4415-a858-393ef890ce1a/attachments/6ebd809610ce4be2b46075e8e2f36c53_image.bin",
    captionAr: "عالم البحر الأحمر",
    captionEn: "Red Sea Underwater World",
    tagAr: "مغامرة بحرية",
    tagEn: "Sea adventure",
  },
  {
    src: "https://customer-assets.emergentagent.com/wingman/4d88747a-9285-4415-a858-393ef890ce1a/attachments/9a0b6ff6beb248c6a79b1368b1bdf0ae_image.bin",
    captionAr: "جولة في سوق الزل، الرياض",
    captionEn: "Tour in Souk Alzal, Riyadh",
    tagAr: "تاريخية",
    tagEn: "Historical",
  },
  {
    src: "https://customer-assets.emergentagent.com/wingman/4d88747a-9285-4415-a858-393ef890ce1a/attachments/300ae9d7197845ac9ca2d144b7a0252a_image.bin",
    captionAr: "اكتشاف الرياض مع مجموعة من السياح ورواد الأعمال",
    captionEn: "Discovering Riyadh with a group of tourists & entrepreneurs",
    tagAr: "تاريخية",
    tagEn: "Historical",
  },
];

export default function Moments() {
  const { isAr } = useLang();

  return (
    <section className="reveal relative py-20 md:py-28 overflow-hidden bg-gradient-to-b from-transparent via-cream-light/40 to-transparent">
      <div className="relative z-10 mx-auto max-w-7xl px-5">
        <div className="max-w-3xl mb-12 md:mb-16">
          <h2
            className={`text-emerald-deep text-balance mb-3 ${isAr ? 'font-display-ar text-4xl sm:text-5xl' : 'font-display-en text-4xl sm:text-5xl'}`}
            data-testid="moments-title"
          >
            {isAr ? "تجارب ضيوفنا" : "Our guests' experiences"}
          </h2>
          <p className="text-emerald-deep/70 text-base md:text-lg"
             style={{ fontFamily: isAr ? 'Cairo' : 'Plus Jakarta Sans' }}>
            {isAr
              ? "كل صورة هي قصة حقيقية، لحظة مرتّبة بعناية من فريق تريبيكس."
              : "Every frame is a real story — a moment carefully arranged by the Tripex team."}
          </p>
        </div>

        {/* Premium editorial gallery — 6 curated guest moments (3 × 2 grid on desktop) */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {PHOTOS.map((p, i) => (
            <article
              key={i}
              className="relative rounded-3xl overflow-hidden group h-[440px] md:h-[520px] shadow-lg hover:shadow-2xl transition-shadow duration-500 isolate"
              data-testid={`moment-${i}`}
            >
              <img
                src={p.src}
                alt={isAr ? p.captionAr : p.captionEn}
                className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-[1200ms] ease-out"
                loading="lazy"
              />
              {/* Darker gradient base for crisp text */}
              <div className="absolute inset-0 bg-gradient-to-t from-emerald-deep/95 via-emerald-deep/50 to-transparent pointer-events-none" />
              {/* Single top-corner category badge */}
              <div className={`absolute top-4 z-10 ${isAr ? 'right-4' : 'left-4'}`}>
                <span
                  className="inline-flex items-center rounded-full bg-gold text-emerald-deep px-3 py-1 text-xs font-bold shadow-md whitespace-nowrap"
                  style={{ fontFamily: isAr ? 'Cairo' : "'Plus Jakarta Sans', sans-serif" }}
                >
                  {isAr ? p.tagAr : p.tagEn}
                </span>
              </div>
              {/* Bottom caption — title only */}
              <div className={`absolute bottom-0 inset-x-0 px-6 pb-6 pt-10 z-10 ${isAr ? 'text-right' : 'text-left'}`} dir={isAr ? 'rtl' : 'ltr'}>
                <p
                  className="text-cream text-lg md:text-xl font-semibold leading-snug"
                  style={{ fontFamily: isAr ? 'Cairo' : 'Plus Jakarta Sans' }}
                >
                  {isAr ? p.captionAr : p.captionEn}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
